

import { useState } from 'react'
import { MuiOtpInput } from 'mui-one-time-password-input'

import { Box, Button, Divider, FormControlLabel, InputBase, InputLabel, Paper, Radio, RadioGroup, Typography} from "@mui/material"
import { alpha, styled } from '@mui/material/styles'
import { updateEmail, updateMobile, updateFirstName, updateLastName, updatePassword,updateRole,updateId, updateOtpCheck,updateWithdrawAccount,updateWithdrawAmount,updateTransactionPinVerification,updateOpenWithdrawRequest,updateWithdraw,updateOtpVerifyPopup,updateWithdrawRequest,updateWithdrawAmountChange, updateAccumulated, updateUserData, updateMemberResponse,updateWhatsapp, updateMembership,updateConrtol, updateProfile,updateMultiple, updateMultipleAccount, updateSwitchedAccount } from "../redux/user_reducer"
import mayi_logo from "../assets/mayi_global_dark.png"
import { useMediaQuery } from 'react-responsive';
import VisibilityIcon from '@mui/icons-material/Visibility';
import {inputStyles} from "../forms/signup_form"
import { useDispatch, useSelector } from "react-redux";
import { Link,useNavigate, useParams,useLocation } from "react-router-dom";
import {jwtDecode} from "jwt-decode"
import CustomAxios from '../utils/CustomAxios';
import CircularProgress from '@mui/material/CircularProgress';
import axios from "axios"
import otpImage from "../assets/otp.webp"
import background from "../assets/Background.webp"
import MessageBar from '../modules/messageBar'
import { useEffect } from 'react'
import { updateSnackBarMessage, updateSnackBarOpen, updateSnackBarSeverity } from "../redux/snackbar";
import CloseIcon from '@mui/icons-material/Close';
import { TranslateText } from '../utils/googletranslator'
import { updateOpen } from '../redux/congrats'

let lastLoginAutoOtpTriggerAt = 0

const OtpVerifyOption=({switchOTP, onGenerateSignupOtp, signupOtpRequested = false, autoGenerate = true, loginDialCode})=>{
    const dispatch=useDispatch()
    const [response,setResponse]=useState('')
    const [otp, setOtp] = useState('')
    const [isloading, setIsloading] = useState(false)
    const [isreloading, setIsReloading] = useState(false)
    const [otpHasSend, setOtpHasSend] = useState(false)
    const [maskedEmail, setMaskedEmail] = useState('');
    const [maskedMobile, setMaskedMobile] = useState('');
    const whatsapp=useSelector(state=>state.user.whatsapp)
    const [verificationType, setVerificationType] = useState('');
    const email = useSelector(state => state.user.email )
    const mobileno = useSelector(state => state.user.mobile_no )
    const id=useSelector(state=>state.user.id)
    const verify = useSelector(state => state.user.otp )
    const url = `${process.env.REACT_APP_BACKEND_BASE_URL}otp_check/`
    const [resend,setResend]=useState(false)
    const withdrawAccount=useSelector(state=>state.user.withdrawAccount)
    const withdrawAmount=useSelector(state=>state.user.withdrawAmount)
    const userbal = useSelector(state => state.user.accumulated)
    const OtpVerifyPopup=useSelector(state=>state.user.OtpVerifyPopup)
    let withdrawId=useSelector(state=>state.user.withdrawId)
    let userreponse= useSelector(state => state.user.member_response)
    let member=useSelector(state=>state.user.member)
    const [error,setError]=useState("")
    const [otp_generate,setOtp_generate]=useState(false)
    const location=useLocation()
    const isLaptop = useMediaQuery({ query: '(min-width: 900px)' });
    const isSignupFlow = Boolean(onGenerateSignupOtp) || verify === "signup" || location.pathname.startsWith('/signup');
    // console.log(verify)
    //const url = "http://127.0.0.1:8000/mayi/otp_check/"

    const param = useParams()
        // console.log(verify)
    const handleChange = (newValue) => {
        setOtp(newValue)
    }
    useEffect(()=>{
        if (switchOTP){
            handleComplete()
        }
    },[switchOTP])
   
    const navigate = useNavigate()
    const handleComplete = async(value) => {
        setIsloading(true)
        setResponse('')
        const user=localStorage.getItem("user")
        // console.log(email)
        // console.log(user,email,value)
        await CustomAxios.post(`otp-verification/`,
        {
            id:id,
            signup_session_id: verify === "signup" ? (localStorage.getItem("signupSessionId") || id) : undefined,
            email:email,
            verifyOtpFor:verify,
            mobile:mobileno,
            package:localStorage.getItem("package"),
            otp:otp,
            cart:verify=='signup'||verify == "login"||verify=="forgot_password"? localStorage.getItem("cart")? localStorage.getItem("cart"):JSON.stringify([]):JSON.stringify([])
        }
    ).then(({data})=>{
        // setIsloading(false)
        // console.log(verify,location.pathname)
        if(verify=="signup" && data.signup_session_id){
            setIsloading(false)
            localStorage.setItem("signupSessionId", data.signup_session_id)
            navigate("/payment-page")
        }
        else if(data.message=='Congratulations, your account have been successfully verified' && (verify=="signup" || verify == "login")){
            const decode=jwtDecode(data.access_token)
            setIsloading(false)

            if (verify === "signup") {
                try {
                    localStorage.removeItem("mayiiq_signup_otp_terms_accepted")
                } catch {
                    // ignore localStorage access issues
                }
            }
            
            // Set tokens and user data first
            // localStorage.setItem('authtoken', data.access_token);
            // localStorage.setItem('refreshToken', data.refresh_token);
            localStorage.setItem("address", JSON.stringify(data.add || []));
            
            // Update Redux state with user data
            dispatch(updateMemberResponse(data))
            dispatch(updateFirstName(decode.first_name))
            dispatch(updateLastName(decode.last_name))
            dispatch(updateEmail(decode.email))
            dispatch(updateRole(decode.role))
            dispatch(updateConrtol(decode.control))
            dispatch(updateId(decode.id))
            dispatch(updateMobile(data.user?.mobileno || mobileno))
            dispatch(updateWhatsapp(data.user?.whatsapp))
            dispatch(updateMembership(decode.member))
            
            // Update profile if available
            if (data.att && data.att.length > 0) {
                dispatch(updateProfile(data.att[0].original))
            }

            if (decode.role=='admin'){
                localStorage.setItem('authtoken', data.access_token);
                localStorage.setItem('refreshToken', data.refresh_token);
                navigate("/")
                return
            }

            // Check for active plan
            CustomAxios.get(`active_plan/${decode.id}`).then(res=>{
                // console.log(res.data)
                if (res.data.message=="Plan activated successfully"){
                    // User has active plan - complete login
                    localStorage.setItem('authtoken', data.access_token);
                    localStorage.setItem('refreshToken', data.refresh_token);
                    if (localStorage.getItem("redirect")){
                        navigate(localStorage.getItem("redirect"))
                    }
                    else if(location.pathname=='/checkout'){
                        dispatch(updateOtpVerifyPopup(false))
                    }
                    else if(location.pathname=='/login' || location.pathname=='/otp-verification' || location.pathname=='/signup'){
                        if (decode.role=='admin'){
                            navigate("/product")
                        }
                        else{
                            navigate("/dashboard")
                        }
                        
                    }
                    else{
                        if (decode.role=='admin'){
                            navigate("/product")
                        }
                        else{
                            navigate("/dashboard")
                        }
                    }
                }
                else{
                    // No active plan - redirect to payment page
                    navigate("/payment-page")
                }
            }).catch(error=>{
                console.log(error)
                // On error, still redirect to payment page
                navigate("/payment-page")
            })
          
        }
        else{
            if (data.message=='Congratulations, your account have been successfully verified' && verify=="forgot_password"){
            const decode=jwtDecode(data.access_token)
            // // console.log(decode)
            localStorage.setItem('authtoken', data.access_token);
            localStorage.setItem('refreshToken', data.refresh_token)
            dispatch(updateEmail(decode.email))
            navigate("/password-change/forgot")
        }
        else if(verify=="profile"){
            if (data.message=='Congratulations, your account have been successfully verified' && verify=="profile"){
                const decode=jwtDecode(data.access_token)
                // console.log(data)
            // // console.log(decode)
            localStorage.setItem('authtoken', data.access_token);
            localStorage.setItem('refreshToken', data.refresh_token)
            dispatch(updateEmail(decode.email))
            navigate("/profile")
            }
            else{
            setResponse(data.message)}
        }
        else if(verify=="withdraw_request" && data.message=="Congratulations, your account have been successfully verified"){
            const payload={
                amount:parseFloat(withdrawAmount-(withdrawAmount*0.0231)).toFixed(2),
                without_deduction:withdrawAmount,
                deduction_amount:parseFloat(withdrawAmount-parseFloat(withdrawAmount-(withdrawAmount*0.0231))).toFixed(2),
                balance:(parseFloat(userreponse?.accumulated?.withdrawal_available)-parseFloat(withdrawAmount)).toFixed(2),
                current_amount:userreponse?.accumulated?.withdrawal_available,
                type:"Deb",
                status:"requested",
                bank_account:withdrawAccount,
                user:id,
                created_by:id
            }
            // console.log(payload,userbal.withdrawal_available)
            CustomAxios.post('withdraw_Request/',payload).then((res) => {
                // console.log(res)
                if (res.status == 201) {
                    handle_withdrawRequest()


                }
                else {
                    dispatch(updateSnackBarSeverity('error'))
                    dispatch(updateSnackBarMessage("Something Went Wrong"))
                    dispatch(updateSnackBarOpen(true))
                    
                    
                    dispatch(updateTransactionPinVerification("not verified"))
                    
                    setIsloading(false)
                }
            })

        }
        else if(verify=="withdraw_update"&& data.message=="Congratulations, your account have been successfully verified"){
            let payload={
                amount:parseFloat(withdrawAmount-(withdrawAmount*0.0231)).toFixed(2),
                without_deduction:withdrawAmount,
                deduction_amount:parseFloat(withdrawAmount-parseFloat(withdrawAmount-(withdrawAmount*0.0231))).toFixed(2),
                balance:(parseFloat(userreponse?.accumulated?.withdrawal_available)-parseFloat(withdrawAmount)).toFixed(2),
                user:id,
                account:withdrawAccount,
                status:'update',
                bank_account:withdrawAccount

    
            }
            CustomAxios.put(`update_withdraw/${withdrawId}`,payload).then((res) => {
                // console.log(res)
                const payload = {
                    user_id: id
                }
                if (res.status == 201 && id) {
                    CustomAxios.post(`get_details/`, payload).then(response => {
                        // console.log(response.data)
                        dispatch(updateWithdrawRequest(response.data.withdrawRequest))
                        dispatch(updateAccumulated(response.data.accumulated))
                        dispatch(updateMemberResponse(response.data))
                        dispatch(updateWhatsapp(response.data.user.whatsapp))
                        dispatch(updateMembership(response.data.user.member))
                        dispatch(updateMultiple(response.data.multiple))
                        dispatch(updateMultipleAccount(response.data.multipleAccounts))
                        dispatch(updateSwitchedAccount(response.data.multipleAccounts.filter(acc=>acc.id==id)))
                    }
                    ).catch(error => {
                        // console.log(error)
                    })
    
                    dispatch(updateSnackBarSeverity('success'))
                    dispatch(updateSnackBarMessage("Successfully Requested"))
                    dispatch(updateSnackBarOpen(true))
                    dispatch(updateTransactionPinVerification("not verified"))
                    dispatch(updateOpenWithdrawRequest(false))
                    dispatch(updateWithdraw(false))
                    dispatch(updateWithdrawAmount(""))
                    dispatch(updateWithdrawAccount(""))
                    dispatch(updateWithdrawAmountChange(false))
                    dispatch(updateOtpVerifyPopup(false))    
                    
                    setIsloading(false)


                }
                else {
                    dispatch(updateSnackBarSeverity('error'))
                    dispatch(updateSnackBarMessage("Something Went Wrong"))
                    dispatch(updateSnackBarOpen(true))
                    dispatch(updateTransactionPinVerification("not verified"))
                    
                    
                    setIsloading(false)
                }
            })
        
        }
        else{
            // console.log("????????????????/","inside the error")
            setError("Invalid OTP. Please enter valid OTP.")
            dispatch(updateSnackBarSeverity('error'))
            dispatch(updateSnackBarMessage("Something Went Wrong"))
            dispatch(updateSnackBarOpen(true))
            dispatch(updateTransactionPinVerification("not verified"))
            setIsloading(false)
        }

    }
        
        // // console.log(data)
        
    }).catch(error=>{
        setIsloading(false)
        // console.log(error)
    })
      }
      const handle_withdrawRequest=async()=>{
        const payload={user_id:id,}
        if(id){
            await CustomAxios.post(`get_details/`, payload).then(response => {
                // console.log(response.data)
                dispatch(updateWithdrawRequest(response.data.withdrawRequest))
                dispatch(updateAccumulated(response.data.accumulated))
                dispatch(updateMemberResponse(response.data))
                dispatch(updateWhatsapp(response.data.user.whatsapp))
                dispatch(updateMembership(response.data.user.member))
                dispatch(updateMultiple(response.data.multiple))
                dispatch(updateMultipleAccount(response.data.multipleAccounts))
                dispatch(updateSwitchedAccount(response.data.multipleAccounts.filter(acc=>acc.id==id)))
                // dispatch(update)
               
            }
            ).catch(error => {
                // console.log(error)
            })
        }
        

        dispatch(updateSnackBarSeverity('success'))
        dispatch(updateSnackBarMessage("Successfully Requested"))
        dispatch(updateSnackBarOpen(true))
        dispatch(updateTransactionPinVerification("not verified"))
        dispatch(updateOpenWithdrawRequest(false))
        dispatch(updateWithdraw(false))
        dispatch(updateWithdrawAmount(""))
        dispatch(updateWithdrawAccount(""))     
        dispatch(updateOtpVerifyPopup(false))           
        setIsloading(false)
      }
      const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleComplete(); 
        }
      };
    const isMobile = useMediaQuery({ maxWidth: 600 });
    const homePage=()=>{
        navigate("/")
    }
    const handleSummit=async ()=>{
        setIsReloading(true)
        setIsloading(true)
        const formData={
           id:id,
            email:email,
            verify:verify,
            verificationType:verificationType
           
        }
        const error = {
            email:""
        }
        //const validate=validateForm(formData)
        
        const response = await CustomAxios.post(`forgot_password/`, formData)
        setIsReloading(false)
        // console.log(response.data)
        if (response.data.message=="otp has been send"){
            dispatch(updateOtpCheck(verify))
            navigate("/otp-verification")
            setResend(false)
            setTime(150)
            setIsloading(false)
        }
        else{
            error.email = response.data.message
            //setErrors(error)
        } 
        //// console.log(validate)
        
    }
    const [time, setTime] = useState(150); // 150 seconds equals 2 minutes and 30 seconds

    useEffect(() => {
      if (time > 0) {
        const timerId = setInterval(() => {
          setTime(prevTime => prevTime - 1);
        }, 1000);
        return () => clearInterval(timerId); // Cleanup interval on component unmount
      }
      else{
setResend(true)
      }
    }, [time]);
useEffect(()=>{
otpHasSend&&setTime(150)
},[otpHasSend])
    const handleRadioChange = (event) => {
        setVerificationType(event.target.value);
      };
      const isLoginOtpFlow = location.pathname === '/login' && verify === 'login'
      useEffect(()=>{
            if (isSignupFlow){
                setOtpHasSend(signupOtpRequested)
                setResend(false)
                setTime(150)
                setOtp_generate(false)
                if (!email && mobileno && !verificationType){
                    setVerificationType("mobile")
                }
                return
            }
            if (location.pathname === '/login' && verify === 'login' && loginDialCode && loginDialCode !== '+91'){
                setVerificationType('whatsapp')
            }
            if (!otp_generate && (!email|| !mobileno)){
                setOtp_generate(true)
            }

          },[signupOtpRequested, isSignupFlow, email, mobileno, verificationType, location.pathname, verify, loginDialCode])
          useEffect(()=>{
            if (isSignupFlow){
                return
            }

            if (location.pathname=='/login'){
                // In login flow we now explicitly control OTP send from the login screen,
                // so avoid auto-generating OTP here.
                return
            }

            if (!otp_generate&& (!email|| !mobileno)){
                handleGenarateOTP('event','generate')
                setOtp_generate(false)
            }
      },[otp_generate, email, mobileno, location.pathname, isSignupFlow])
      const handleGenarateOTP = async(e,gen) => {
        if (isSignupFlow && gen === "generate" && onGenerateSignupOtp) {
            setIsloading(true)
            setResponse('')
            setError("")
            const otpMethod = verificationType || "mobile"
            if (otpMethod === "email" && !email) {
                setIsloading(false)
                setError("Email is required for email OTP.")
                return
            }
            const result = await onGenerateSignupOtp(otpMethod)
            setIsloading(false)
            if (result?.ok) {
                setTime(150)
                setOtpHasSend(true)
                setResend(false)
                setError("")
            } else {
                setError(result?.message || "Unable to send OTP")
            }
            return
        }

        if (gen=="generate"){
            setIsloading(true)
        }
        setResponse('')
       try{
        const response = await CustomAxios.post(`otp_generation/`,
                {
                    id:id,
                    verificationType:verificationType?verificationType:"mobile",
                    email:email,
                    verify:verify
                })
                if(response.data.message){
                    // console.log("otp has been send")
                    setIsloading(false)
                    setTime(150)
                    setOtpHasSend(true)
                    setResend(false)
                    setError("")
                }
       }
       catch (e) {
        setIsloading(false)
        setError(e?.response?.data?.message || "Unable to send OTP")
       }
    }
// console.log(verificationType,otpHasSend)
    const formatTime = (seconds) => {
      const minutes = Math.floor(seconds / 60);
      const remainingSeconds = seconds % 60;
      return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
    };
    const maskEmail = (email) => {
        const [localPart, domain] = email.split('@');
        if (localPart.length <= 2) {
            return `${localPart}@${domain}`; // If local part is too short to mask
        }
        const visiblePart = localPart.slice(-2); // Last 2 characters
        const maskedPart = 'X'.repeat(localPart.length - 2); // Mask all but the last 2 characters
        return `${maskedPart}${visiblePart}@${domain}`;
    };
    const maskMobileNo = (mobileNumber) => {
        if (mobileNumber.length <= 2) {
            return mobileNumber; // If mobile number is too short to mask
        }
        
        const visiblePart = mobileNumber.slice(-2); // Last 2 digits
        const maskedPart = 'X'.repeat(mobileNumber.length - 2); // Mask all but the last 2 digits
        return `${maskedPart}${visiblePart}`;
    };
// console.log(mobileno)
    useEffect(() => {
        if (email) {
            setMaskedEmail(maskEmail(email));
        }
        if (mobileno) {
            setMaskedMobile(maskMobileNo(mobileno));
        }
    }, [email,mobileno]);
    const handleClose = () => {
        dispatch(updateOtpVerifyPopup(false))
        dispatch(updateWithdrawAccount(""))
        dispatch(updateWithdrawAmount(""))
        // dispatch(updateWithdraw(false))
        dispatch(updateTransactionPinVerification("not verified"))
        // setErrors({})
        // setIsVerified(true)
        // setOpen(false);
    }

    return <Box sx={[inputStyles.paper,OtpVerifyPopup&&{position: (location.pathname!=='/checkout'||location.pathname=='/signup'||isLaptop)&&"absolute",top:"50%",left:"50%", transform:(location.pathname!=='/checkout'||location.pathname=='/signup'||isLaptop)&& 'translate(-50%, -50%)',}]}>
    {!OtpVerifyPopup&& location.pathname!='/signup'&& location.pathname!='/login'&& <Box src={mayi_logo} component='img' sx={inputStyles.logo} onClick={homePage}/>}
   
    <Box sx={{ display: "flex", flexDirection: 'column', width: "100%",gap:"16px" }}>
        <Box sx={{ display: "flex", flexDirection: 'row', width: "100%",justifyContent:"space-between",alignItems:"center"}}>
            {location.pathname!='/login'&&
    <TranslateText sx={inputStyles.verifyLabel} > {OtpVerifyPopup?"OTP Verification":"Verify Your Account"}</TranslateText>}
    {OtpVerifyPopup&&location.pathname!=='/checkout'&&location.pathname!=='/signup' &&
    <CloseIcon sx={{ fontWeight: "600", lineHeight: "24px",cursor:"pointer" }} onClick={handleClose} />}
    </Box>

    <Box sx={{display:"flex",flexDirection:"column",marginBottom:OtpVerifyPopup?"0px":"0px"}}>
        {isLoginOtpFlow && loginDialCode === '+91' && (
            <>
                <TranslateText sx={[inputStyles.label,{marginTop:!OtpVerifyPopup&&"-16px"}]} color="grey.500">Choose how you'd like to receive the code:</TranslateText>
                <RadioGroup
                    aria-labelledby="login-otp-method"
                    name="loginOtpMethod"
                    value={verificationType}
                    onChange={handleRadioChange}
                    sx={{ mt: 0.5, display: "flex", flexDirection: "row", gap: 2, flexWrap: "wrap" }}
                >
                    <FormControlLabel value="sms" control={<Radio />} label={<TranslateText>SMS</TranslateText>} sx={{ marginBottom: 0, padding: 0 }} />
                    <FormControlLabel value="whatsapp" control={<Radio />} label={<TranslateText>WhatsApp</TranslateText>} sx={{ marginBottom: 0, padding: 0 }} />
                </RadioGroup>
                <TranslateText sx={inputStyles.verificationLabel} color="grey.500">We'll send a verification code to your number ending in {maskedMobile || mobileno}</TranslateText>
            </>
        )}
        {isLoginOtpFlow && loginDialCode && loginDialCode !== '+91' && mobileno && (
            <TranslateText sx={[inputStyles.verificationLabel, { marginTop: !OtpVerifyPopup && "-16px" }]} color="grey.500">We'll send the code via WhatsApp to your number ending in {maskedMobile || mobileno}</TranslateText>
        )}
        {!isLoginOtpFlow && email&&mobileno&&
            <TranslateText sx={[inputStyles.label,{marginTop:!OtpVerifyPopup&&"-16px"}]} color="grey.500"> Choose how you'd like to verify your account:</TranslateText>}
        {!isLoginOtpFlow && (
            <Box sx={{display:"flex",flexDirection:"column",marginTop:OtpVerifyPopup?"16px":"0px",}}>
               
                 <Box sx={{marginBottom:{xs:"0px",sm:"20px",}}}>
                
                 <RadioGroup
                    aria-labelledby="demo-error-radios"
                    name="quiz"
                    value={verificationType}
                    onChange={handleRadioChange}
                    sx={OtpVerifyPopup&&{display:"flex",flexDirection:{xs:"column",sm:"row"},gap:"24px",justifyContent:"space-between",}}
                    >
                        { email&& <Box sx={{width:OtpVerifyPopup?{xs:"100%",sm:"47%"}:"100%"}}>
                            <FormControlLabel value="email" control={<Radio />} label={<TranslateText>Email Verification</TranslateText>} sx={{marginBottom:0,padding:0, }} />
                            <TranslateText sx={inputStyles.verificationLabel} color="grey.500">We'll send a verification code to your email address {maskedEmail&&maskedEmail}</TranslateText>
                        </Box>}
                        <Box sx={{width:OtpVerifyPopup &&location.pathname!='/checkout'?{xs:"100%",sm:"47%"}:"100%"}}>
                        { mobileno&&email&&  <FormControlLabel value="mobile" control={<Radio />} label={<TranslateText>Mobile Verification</TranslateText>} sx={{marginBottom:0,padding:0}}/>}
                        {mobileno&&<TranslateText>Mobile Verification</TranslateText>}
                        {mobileno&&
                            <TranslateText sx={inputStyles.verificationLabel} color="grey.500">{whatsapp?"We'll send a verification code to your Whatsapp number ending in":"We'll send a verification code to your mobile number ending in"}  {maskedMobile&&maskedMobile}</TranslateText>}
                        </Box>

                    </RadioGroup>
                 </Box>
            </Box>
        )}
    </Box>
    <TranslateText  sx={{marginBottom: "12px", fontWeight: 400, fontSize: "14px", color: "grey.900", textAlign:OtpVerifyPopup &&location.pathname!='/checkout'? "center":"left" }} color="grey.500">Please enter the code below to complete your account setup</TranslateText>
    <Box sx={{ display: "flex", flexDirection: 'column',gap:"16px", width: "100%",justifyContent:"center",maxWidth:"360px" ,alignSelf:location.pathname=='/checkout'?'start':"center"}}>
    <MuiOtpInput sx={{pointerEvents:otpHasSend?"auto":"none"}} gap={1} value={otp} length={6} onKeyDown={(e)=>handleKeyPress(e)} onChange={handleChange}/>
    {otpHasSend && time>0&& <TranslateText sx={{fontWeight: 400, fontSize: "12px",lineHeight:"16px",textAlign:OtpVerifyPopup &&location.pathname!='/checkout'?"center":"left"}} color="error">Resend Code ( {formatTime(time)} ) remaining </TranslateText>}
        <TranslateText sx={{fontWeight: 400, fontSize: "14px", color:"error.light",}}>{response}</TranslateText>

    </Box>
    <TranslateText sx={{fontWeight: 400, fontSize: "16px",lineHeight:"16px",textAlign:OtpVerifyPopup &&location.pathname!='/checkout' ?"center":"left",marginTop:"-16px"}} color="error">{error}</TranslateText>
    <Box sx={{display:"flex",gap:"20px",alignItems:"center",justifyContent:"space-between",marginTop:OtpVerifyPopup?"0px":"0px",flexDirection:{xs:"column",sm:"row"}}}>
              {!otpHasSend ?(
                <Button
                  disabled={(isLoginOtpFlow && loginDialCode === '+91' && !['sms','whatsapp'].includes(verificationType)) || (!isLoginOtpFlow && email && verificationType==='') || isloading}
                  variant="contained"
                  sx={inputStyles.otpbutton}
                  onClick={(e)=>handleGenarateOTP(e,"generate")}
                >
                  {isloading? <CircularProgress color="inherit" size={30}/> : <TranslateText>Send OTP</TranslateText>}
                </Button>
              ) : (
                <>
                  {location.pathname!='/signup'&&
                    <Button
                      disabled={otp.length<6||isloading?true:false}
                      variant="contained"
                      sx={inputStyles.otpbutton}
                      onClick={(e)=>{handleComplete(e)}}
                    >
                      {isloading? <CircularProgress color="inherit" size={30}/> : <TranslateText>Submit</TranslateText>}
                    </Button>
                  }
                </>
              )}
                <Box sx={{display:"flex",alignSelf:"end",gap:"10px",alignSelf:"center"}}>
            
                {resend&& <TranslateText sx={{alignSelf:"start",color:"primary.light",cursor:"pointer",display:"flex"}} onClick={(e)=>handleGenarateOTP(e,"regenerate")}>{"Resend OTP"}</TranslateText>}
        </Box>
      
        
        </Box>
        
    </Box>
    
</Box>
}

export default OtpVerifyOption
